// Серебро (🪙) — основная внутриигровая валюта: за игру и тренировку, без покупки за деньги и без вывода.
// Значения — Economy v0.1 (docs/spec/08_economy_v0.1.txt, разбор — docs/ECONOMY_V01_REVIEW.md).

export const ECONOMY = {
  /** публичные турниры: серебро за стадию выбывания (раунд → серебро) и чемпиону */
  place: {
    4: { 1: 80, 2: 200 },
    8: { 1: 50, 2: 125, 3: 300 },
  } as Record<number, Record<number, number>>,
  champion: { 4: 900, 8: 1300 } as Record<number, number>,
  /** быстрый 1 на 1: серебро за первые rewardedPerDay матчей в сутки (дальше — только рейтинг и статистика) */
  quick: { win: 25, loss: 10, rewardedPerDay: 5 },
} as const;

/** Публичные турниры по билету */
export const PUBLIC_CUP_SIZES = [4, 8] as const;
export type PublicCupSize = (typeof PUBLIC_CUP_SIZES)[number];

/** Серебро за место в публичном турнире: eliminatedIn — раунд выбывания, null у чемпиона. */
export const placeReward = (size: number, eliminatedIn: number | null): number =>
  eliminatedIn === null ? (ECONOMY.champion[size] ?? 0) : (ECONOMY.place[size]?.[eliminatedIn] ?? 0);

/** Наибольшая награда турнира (для плитки «до 1300 🪙») */
export const maxReward = (size: number): number => ECONOMY.champion[size] ?? 0;

/** Серебро за быстрый 1 на 1 (в пределах суточного лимита) */
export const quickReward = (won: boolean): number => (won ? ECONOMY.quick.win : ECONOMY.quick.loss);
